import React from 'react';
import SalesDetailPage from './SalesDetailPage';
import { SORT_TYPES } from '../constants/sortTypes';
import {
  buildMemberFilterGroups,
  buildMemberApiFilters,
  memberColumns,
  memberReportBaseConfig,
  renderMemberCell,
} from '../constants/membershipReportShared';
import { currencyFormatter } from '../utils/reportingUtils';

const DAYS_FILTER = { id: 'lapsed_days', label: 'Days Since Lapsed' };

const LAPSED_COLUMNS = memberColumns([
  { id: 'lapsed_on', label: 'Lapsed', defaultVisible: true, sortable: true, sortType: 'date' },
  { id: 'months_as_member', label: 'Months as Member', defaultVisible: true, sortable: true, sortType: 'number' },
]);

const LAPSED_CONFIG = {
  ...memberReportBaseConfig({
    slug: 'lapsed',
    title: 'Lapsed Members',
    sidebarKey: 'memberships_lapsed',
    localStorageName: 'reportingMembershipsLapsedColumns',
  }),
  pageSubtitle: 'Former members whose membership has ended and who have not rejoined — your win-back list.',
  columns: LAPSED_COLUMNS.columns,
  sortTypes: SORT_TYPES,
  getDefaultVisibleColumns: LAPSED_COLUMNS.getDefaultVisibleColumns,
  getDefaultHiddenColumns: LAPSED_COLUMNS.getDefaultHiddenColumns,
  defaultSortRules: [{ field: 'lapsed_on', direction: 'desc' }],
  emptyMessage: 'No lapsed members.',

  buildFilterGroups: (venueOwnerships) => buildMemberFilterGroups({
    venueOwnerships, statuses: ['canceled', 'unpaid'], daysFilter: DAYS_FILTER,
  }),
  buildDetailApiFilters: buildMemberApiFilters(DAYS_FILTER.id),

  buildKpiCards: (current) => [
    { label: 'Lapsed Members', value: (current.lapsed_members || 0).toLocaleString() },
    { label: 'Lost MRR', value: currencyFormatter.format(current.lost_mrr || 0) },
    { label: 'Avg Months as Member', value: (current.avg_months_as_member || 0).toLocaleString() },
    { label: 'Lapsed in Last 30 Days', value: (current.lapsed_recently || 0).toLocaleString() },
  ],

  renderCellValue: renderMemberCell(['lapsed_on']),
};

function ReportingMembershipsLapsedPage(props) {
  return <SalesDetailPage {...props} config={LAPSED_CONFIG} />;
}

export default ReportingMembershipsLapsedPage;
